import { BrowserRouter as Router, Routes, Route, useNavigate, useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminDashboardPage from "./pages/AdminDashboardPage";
import DocumentSearchPage from "./pages/DocumentSearchPage";
import AccessibilityMenu from "./components/AccessibilityMenu";
import { adminAPI } from "./services/api";
import { Toaster } from "react-hot-toast";

/**
 * Intercepts the OAuth callback token from the URL, stores it,
 * and redirects to the admin dashboard.
 */
function OAuthCallbackHandler({ children }: { children: React.ReactNode }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const token = searchParams.get("token");
    if (token) {
      localStorage.setItem("admin_token", token);
      // Fetch user info with the new token and store it
      adminAPI.getCurrentUser().then((data) => {
        localStorage.setItem("admin_user", JSON.stringify(data.user));
      }).catch(() => {
        // Token may still be valid even if user info fetch fails
      });
      // Remove token from URL
      searchParams.delete("token");
      setSearchParams(searchParams, { replace: true });
      navigate("/dashboard", { replace: true });
    }
  }, [searchParams, setSearchParams, navigate]);

  return <>{children}</>;
}

function App() {
  return (
    <Router>
      <OAuthCallbackHandler>
        <div className="App">
          <Routes>
            <Route path="/" element={<DocumentSearchPage />} />
            <Route path="/admin" element={<AdminLoginPage />} /> 
            <Route path="/dashboard" element={<AdminDashboardPage />} />
          </Routes>
          {/* <AccessibilityMenu /> */}
          <Toaster
            position="top-right"
            toastOptions={{
              duration: 3000,
              // Brand-navy background with white text so toasts read clearly
              // instead of white-on-white.
              style: {
                background: "#002B7A", // merced-blue-700
                color: "#ffffff",
                fontSize: "0.875rem",
                fontWeight: 500,
                borderRadius: "0.5rem",
                padding: "0.75rem 1rem",
                boxShadow:
                  "0 10px 25px -5px rgba(0,43,122,0.35), 0 4px 6px -4px rgba(0,0,0,0.2)",
              },
              success: {
                style: { background: "#184DAD" }, // merced-blue (action blue)
                iconTheme: { primary: "#ffffff", secondary: "#184DAD" },
              },
              error: {
                style: { background: "#B2432A" }, // merced-rust
                iconTheme: { primary: "#ffffff", secondary: "#B2432A" },
              },
              loading: {
                iconTheme: { primary: "#EAAA00", secondary: "#002B7A" }, // gold spinner
              },
            }}
          />
        </div>
      </OAuthCallbackHandler>
    </Router>
  );
}

export default App;
